var map = {
	"./fullofcacti.png": "3833",
	"./homeplus.png": "6c2f",
	"./le-petit.png": "f379",
	"./monster.png": "2322",
	"./moon.png": "d2e0",
	"./mushi.png": "415d",
	"./muxuan.png": "dac4",
	"./papaya.png": "b5ae",
	"./ramen.png": "6e20",
	"./sweetme.png": "49d9",
	"./weiwei.png": "4379",
	"./youngji.png": "c948"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "795a";